import { useDispatch, useSelector } from "react-redux";
import RevenueTermsClient from "@api/revenueterms";
import AlertModalAction from "@common/redux/actions/AlertModalAction";

export const useRevenueTermsProfilesState = () => {
  const data = useSelector((state) => state.revenueTermsProfiles);
  const dispatch = useDispatch();

  const setState = (payload) =>
    dispatch({ type: "REVENUE_TERMS_REDUCER", payload });

  return [data, setState];
};

export const useRevenueTermsProfilesGrid = () => {
  const [data, setState] = useRevenueTermsProfilesState();

  const onRowClick = (activeRow) => setState({ activeRow });

  const onActiveRowChange = () => {
    const { activeRow, selectedOperator } = data;

    if (!activeRow || !activeRow?.id) {
      return;
    }

    setState({ profileLoading: true });

    RevenueTermsClient.getProfile(selectedOperator, activeRow.id).then(
      (options) => setState({ profileLoading: false, options }),
      () => setState({ profileLoading: false }),
    );
  };

  return {
    ...data,
    onActiveRowChange,
    onRowClick,
  };
};

export const useRevenueTermsProfilesOptions = () => {
  const [{ options, profileLoading, activeRow, selectedOperator }, setState] =
    useRevenueTermsProfilesState();
  const { fetchProfiles } = useRevenueTermsProfilesOperator();

  const onOptionChange = async (option) => {
    const index = options.findIndex((opt) => opt.code === option.code);
    const newOptions = [...options];
    newOptions[index] = { ...option };
    setState({ options: newOptions });
  };

  const fetchNewProfile = () => {
    if (!selectedOperator) {
      return;
    }

    setState({ profileLoading: true });
    RevenueTermsClient.newProfile(selectedOperator).then((options) => {
      setState({ options, profileLoading: false });
    });
  };
  const onProfileSave = (complete = false) => {
    RevenueTermsClient.updateProfile(
      selectedOperator,
      activeRow?.id ?? 0,
      options,
      complete,
    ).then(() => {
      const verb = activeRow?.id === 0 ? "created" : "updated";
      fetchProfiles();
      AlertModalAction.open(`Profile successfully ${verb}!`, "Success");
    });
  };

  const onNewProfileClick = () => {
    setState({ activeRow: { id: 0 } });
    fetchNewProfile();
  };

  return {
    onNewProfileClick,
    fetchNewProfile,
    selectedOperator,
    options,
    activeRow,
    profileLoading,
    onOptionChange,
    onProfileSave,
  };
};

export const useRevenueTermsProfilesOperator = () => {
  const operators = useSelector((state) =>
    state.operators.filter((x) => x.value !== -1),
  );
  const [data, setState] = useRevenueTermsProfilesState();
  const { selectedOperator } = data;

  const onOperatorChange = (_, { value }) =>
    setState({ selectedOperator: value, activeRow: { id: null } });

  const fetchProfiles = () => {
    if (!selectedOperator) {
      if (operators.length === 1) {
        setState({ selectedOperator: operators[0].value });
      }
      return;
    }

    setState({ loading: true });
    RevenueTermsClient.getProfiles(selectedOperator).then(
      ({ data, rowDef, headerDef, span }) =>
        setState({ data, rowDef, headerDef, loading: false, span }),
      () => setState({ loading: false }),
    );
  };

  return {
    ...data,
    fetchProfiles,
    operators,
    onOperatorChange,
  };
};

export default useRevenueTermsProfilesState;
